import styled from "styled-components";

import { v, b, s } from "./../../styles/variables";

export const SPage = styled.main`
    transition: 0.3s ease padding;
    
    @media ${b.sm} {
       
    }
    @media ${b.lg} {
       
    }
`;